<template>
  <div>
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="dialogVisible = true"
      destroy-on-close
    >
      添加空投记录
    </el-button>
    <el-dialog
      :visible="dialogVisible"
      title="添加空投记录"
      width="600px"
      @close="closeDialog"
      append-to-body
    >
      <el-form :model="record" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="用户ID：" prop="userId">
          <el-input v-model="record.userId"></el-input>
        </el-form-item>
        <el-form-item label="金额：" prop="amount">
          <el-input v-model="record.amount"></el-input>
        </el-form-item>
        <el-form-item label="币种：" prop="coinType">
          <!-- <el-input v-model="record.coinType"></el-input> -->
          <el-select v-model="record.coinType" clearable placeholder="请选择">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'CreateAirdropRecord',
  data() {
    return {
      dialogVisible: false,
      record: {
        userId: '',
        amount: '',
        coinType: ''
      },
      rules:{
        userId:[{required:true,message:'请填写userId',trigger:blur}],
        amount:[{required:true,message:'请填写金额',trigger:blur}],
        coinType:[{required:true,message:'请选择币种',trigger:blur}],
      }
    };
  },
  computed: {
    ...mapState('airdrop', ['checkTask','coinList']),
   
  },
  methods: {
    ...mapActions('airdrop', ['createRecord']),
    closeDialog() {
      this.dialogVisible = false;
      this.record = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.createRecord({
            ...this.record,
            taskId: this.checkTask.id
          }).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('onSuccess');
          });
        }
      });
    }
  }
};
</script>

<style lang="less"></style>
